import i18n from "@/common/i18n";
export const orderStatus = [{
  label: `${i18n.t("lang.k_025001")}`,
  value: false
}, {
  label: `${i18n.t("lang.k_025002")}`,
  value: 'SUCCESS'
}, {
  label: `${i18n.t("lang.k_025003")}`,
  value: 'WAITING'
}, {
  label: `${i18n.t("lang.k_025004")}`,
  value: 'FAILED'
}, {
  label: `${i18n.t("lang.k_025005")}`,
  value: 'CREATED'
}];
export const buyTypeList = [{
  label: `${i18n.t("lang.k_025006")}`,
  value: false
}, {
  label: `${i18n.t("lang.k_025007")}`,
  value: 1
}, {
  label: `${i18n.t("lang.k_025008")}`,
  value: 3
}, {
  label: `${i18n.t("lang.k_025009")}`,
  value: 4
}];
export const searchOptions = [{
  label: `${i18n.t("lang.k_025010")}`,
  value: 'order_no',
  placeholder: `${i18n.t("lang.k_025011")}`
}, {
  label: `${i18n.t("lang.k_025012")}`,
  value: 'address_info',
  placeholder: `${i18n.t("lang.k_025013")}`
}, {
  label: `${i18n.t("lang.k_025014")}`,
  value: 'goods_name',
  placeholder: `${i18n.t("lang.k_025015")}`
}, {
  label: `${i18n.t("lang.k_025016")}`,
  value: 'webinar_info',
  placeholder: `${i18n.t("lang.k_025017")}`
}, {
  label: `${i18n.t("lang.k_025018")}`,
  value: 'trade_no',
  placeholder: `${i18n.t("lang.k_025019")}`
}];